export default {
  methods: {
    orderedSectionObjects(catType = null) {
      // console.log("orderedSectionObjects");
      let sectionKeys = this.sectionOrder;
      if (!sectionKeys) return [];
      let sectionObjects = this.sectionObjects;
      if (catType && this.specialFields?.[catType])
        sectionObjects = this.specialFields[catType];
      let rtn = [];
      sectionKeys.forEach((sKey) => {
        let obj = sectionObjects[sKey];
        if (obj) {
          obj.key = sKey;
          rtn.push(obj);
        }
      });
      return rtn;
    },

    contentSectionsDownloaded(cObj) {
      // console.log("contentSectionsDownloaded");
      let sectionKeys = this.sectionOrder;
      if (!sectionKeys) return [];
      let sectionObjects = this.sectionObjects;
      if (cObj.catType && this.specialFields?.[cObj.catType])
        sectionObjects = this.specialFields[cObj.catType];
      // console.log(sectionObjects);
      let rtn = [];
      sectionKeys.forEach((sKey) => {
        let obj = sectionObjects[sKey];
        if (obj) {
          obj.key = sKey;
          obj.value = cObj[sKey] ? cObj[sKey] : null;
          rtn.push(obj);
        }
      });
      return rtn;
    },
  },
};
